import { render, staticRenderFns } from "./StockProducts.vue?vue&type=template&id=8122af6e"
import script from "./StockProducts.vue?vue&type=script&lang=js"
export * from "./StockProducts.vue?vue&type=script&lang=js"
import style0 from "./StockProducts.vue?vue&type=style&index=0&id=8122af6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports